import { useMemo } from 'react';

import { usePermissionGroupsAndRoles } from 'app/client/utilities/hooks/useCheckPermissionGroups';

import { SEARCH_TYPES } from '../config/searchTypes';
import { DEFAULT_TAB_KEY } from '../config/constants';

/**
 * The search types the user may read, so no tab offers results the API will refuse to return.
 *
 * @returns {Object} The allowed index keys and the tab keys to render.
 */
export default () => {
  const { permissionGroups, roles } = usePermissionGroupsAndRoles();

  return useMemo(() => {
    const allowAll = !__PRODUCTION__ && roles.includes('developer');

    const indexKeys = Object.keys(SEARCH_TYPES).filter(
      (indexKey) => allowAll || permissionGroups.includes(SEARCH_TYPES[indexKey].permissionGroup),
    );

    return {
      indexKeys,
      tabKeys: [DEFAULT_TAB_KEY, ...indexKeys.map((indexKey) => SEARCH_TYPES[indexKey].tabKey)],
    };
  }, [permissionGroups, roles]);
};
